import { render, staticRenderFns } from "./IntroOutroAdd.vue?vue&type=template&id=2a8e7159&"
import script from "./IntroOutroAdd.vue?vue&type=script&lang=js&"
export * from "./IntroOutroAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports